/** @jsxImportSource @emotion/react */
import React, {useEffect, useState} from 'react'
import Tools from "script/sweet-tools.mjs";
import './print.css'
import {log} from "mathjs";
import moment from "moment/moment";
import fixNum from "../../script/fixNum.mjs";
import {nanoid} from "nanoid";


const EPIMALTER = ({mmEpimAlterId}) => {

    const dateFormat = 'YYYY年MM月DD日';
    //变更记录主数据
    const [epim, setEpim] = useState({})
    //出口数量变更
    const [pnumList, setPnumList] = useState([])
    //进口数量变更
    const [mnumList, setMnumList] = useState([])
    //单耗变更类型的款号集合
    const [styleNoList, setStyleNoList] = useState([]);
    //单耗变更类型的物料集合
    const [alterMrowList, setAlterMrowList] = useState([]);
    //单耗变更类型记录
    const [consumptionList, setConsumptionList] = useState([]);
    //单耗变更类型记录 物料项号
    const [consumptionMrowNoList, setconsumptionMrowNoList] = useState([]);
    //单耗变更类型记录 成品项号
    const [consumptionProwNoLists, setconsumptionProwNoLists] = useState([]);

    //品名规格变更
    const [specList, setSpecList] = useState([]);
    //海关编码变更
    const [hsAlterList, setHsAlterList] = useState([]);
    //成品申报要素变更
    const [pHsDeclareAlterList, setPHsDeclareAlterList] = useState([]);
    //料件申报要素变更
    const [mHsDeclareAlterList, setMHsDeclareAlterList] = useState([]);

    //余料结转变更-结转明细
    const [epimMtrf, setEpimMtrf] = useState(null);
    const [epimMtrfRows, setEpimMtrfRows] = useState([]);

    //发生出口数量变更的现手册金额总和，原手册金额总和，增加金额总和
    const [epimPamtTotal, setEpimPamtTotal] = useState(0);
    const [originEpimPamtTotal, setOriginEpimPamtTotal] = useState(0);
    const [addPamtTotal, setAddPamtTotal] = useState(0);

    //发生进口数量变更的现手册金额总和，原手册金额总和，增加金额总和
    const [epimRowAmtTotal, setEpimRowAmtTotal] = useState(0);
    const [originEpimRowAmtTotal, setOriginEpimRowAmtTotalTotal] = useState(0);
    const [addRowAmtTotal, setAddRowAmtTotal] = useState(0);

    const [tableCount, setTableCount] = useState([0, 0, 0, 0, 0, 0])

    useEffect(() => {
        if (mmEpimAlterId) {
            (async () => {
                await Promise.all([
                    init()
                    , initPnumList()
                    , initMnumList()
                    , initUsageProwList()
                    , initUsageMrowList()
                    , initUsageConsumptionList()
                    , initSpecList()
                    , initHsAltList()
                    , initMHsDeclareAltList()
                    , initPHsDeclareAltList()
                ]).then((results) => {
                    let epim = results[0];
                    let pnumList = results[1];
                    let mnumList = results[2];
                    let alterProwList = results[3];
                    let alterMrowList = results[4];
                    let consumptionList = results[5];
                    let specList = results[6];
                    let hsAlterList = results[7];
                    let mHsDeclareAlterList = results[8];
                    let pHsDeclareAlterList = results[9];

                    if (pnumList) {
                        let epimPamtTotal = 0;
                        let originEpimPamtTotal = 0;
                        let addPamtTotal = 0;
                        pnumList.forEach(i => {
                            epimPamtTotal += i.epimPamt;
                            originEpimPamtTotal += i.originEpimPamt;
                            addPamtTotal += i.addPamt;
                        })
                        setEpimPamtTotal(epimPamtTotal)
                        setOriginEpimPamtTotal(originEpimPamtTotal)
                        setAddPamtTotal(addPamtTotal)
                    }

                    if (mnumList) {
                        let epimRowAmtTotal = 0;
                        let originEpimRowAmtTotal = 0;
                        let addRowAmtTotal = 0;
                        mnumList.forEach(i => {
                            epimRowAmtTotal += i.epimRowAmt;
                            originEpimRowAmtTotal += i.originEpimRowAmt;
                            addRowAmtTotal += i.addRowAmt;
                        })
                        setEpimRowAmtTotal(epimRowAmtTotal)
                        setOriginEpimRowAmtTotalTotal(originEpimRowAmtTotal)
                        setAddRowAmtTotal(addRowAmtTotal)
                    }


                    setEpim(epim);
                    setPnumList(pnumList);
                    setMnumList(mnumList);
                    setSpecList(specList);
                    setHsAlterList(hsAlterList);
                    setPHsDeclareAlterList(pHsDeclareAlterList);
                    setMHsDeclareAlterList(mHsDeclareAlterList);

                    setConsumptionList(consumptionList);
                    //单耗变更记录转 项号集合
                    let prowNoList = new Set();
                    let mrowNoList = new Set();
                    if (consumptionList) {
                        consumptionList.map(i => {
                            prowNoList.add(Number(i.epimProwNo));
                            mrowNoList.add(Number(i.epimMrowNo));
                        })
                    }

                    //单耗变更 三个一组 如果不满三个 补充一个用来占位以免每列宽度样式超长
                    let prowNoLists = [];
                    if (prowNoList) {
                        let prowNoMapList = [];
                        prowNoList.forEach(i => {
                            prowNoMapList.push({
                                id: nanoid(),
                                epimProwNo: i,
                            })
                        })
                        prowNoMapList.sort((a, b) => a.epimProwNo - b.epimProwNo);

                        prowNoLists = chunkArray(prowNoMapList, 3);
                        prowNoLists.map(item => {
                            if (item.length < 3) {
                                item.push({
                                    id: nanoid(),
                                    epimProwNo: null,
                                })
                            }
                        });
                    }
                    setconsumptionProwNoLists(prowNoLists);
                    // setconsumptionMrowNoList([...mrowNoList]);
                    setconsumptionMrowNoList([...mrowNoList].sort((a, b) => a - b));

                    //表格序号
                    let tableCount = [0, 0, 0, 0, 0, 0, 0, 0]
                    let count = 0;
                    if (pnumList.length > 0) {
                        count++;
                        tableCount[0] = count;
                    }
                    if (mnumList.length > 0) {
                        count++;
                        tableCount[1] = count;
                    }
                    if (consumptionList.length > 0) {
                        count++;
                        tableCount[2] = count;
                    }
                    if (specList.length > 0) {
                        count++;
                        tableCount[3] = count;
                    }
                    if (hsAlterList.length > 0) {
                        count++;
                        tableCount[4] = count;
                    }

                    if (pHsDeclareAlterList.length > 0) {
                        count++;
                        tableCount[5] = count;
                    }
                    if (mHsDeclareAlterList.length > 0) {
                        count++;
                        tableCount[6] = count;
                    }
                    if (epimMtrfRows.length > 0) {
                        count++;
                        tableCount[7] = count;
                    }


                    setTableCount(tableCount);
                });
            })()
        }
    }, [mmEpimAlterId]);


    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    }

    //查询变更记录
    const init = async () => {
        console.log(mmEpimAlterId);
        const data = await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/oneMmEpimAlterForPrint', {mmEpimAlterId: mmEpimAlterId});
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });

        if (data != null && data?.altSrcType === 'EPIMTRF') {
            const mtrf = await Tools.runAsync(async () => {
                return await Tools.http.post('/mm/epim/oneEpimMtrf', {epimMtrfId: data.epimMtrfId});
            }, {
                error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
            });
            setEpimMtrf(mtrf.epimMtrfDR)
            setEpimMtrfRows(mtrf.epimMtrfRowDRList);
        }


        return data;
    }
    //查询出口数量变更类型的记录明细
    const initPnumList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'PNUM'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    //查询进口口数量变更类型的记录明细
    const initMnumList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'MNUM'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }

    //查询单耗变更类型的记录明细的款号
    const initUsageProwList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowProwForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'USAGE'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    const initUsageMrowList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowMrowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'USAGE'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    const initUsageConsumptionList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowConsumptionForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'USAGE'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }

    //查询品名规格变更类型的记录明细
    const initSpecList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'PSPEC'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    //查询海关编码变更类型的记录明细
    const initHsAltList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'PNO'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    //查询成品申报要素变更类型的记录明细
    const initPHsDeclareAltList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'PDC'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }
    //查询料件申报要素变更类型的记录明细
    const initMHsDeclareAltList = async () => {
        return await Tools.runAsync(async () => {
            return await Tools.http.post('/mm/epim/listMmEpimAlterRowForPrint', {
                mmEpimAlterId: mmEpimAlterId,
                alterRowType: 'MDC'
            });
        }, {
            error: {content: (err) => `查询失败: ${err.message}`}, loading: {show: false}, success: {show: false},
        });
    }

    const printCss = {
        /*@media print {
                    body {zoom: 0.62}
                        .no-print{
                display:none;
            }
        }*/

        "@media print": {
            "body": {zoom: "0.62"}
            //"& .print-container": {
            //    overflow: "hidden"
            //},
            /*"& .order-edit-content":{
                display: "none"
            }*/
        },
        // 去除页眉页脚
        //"@page": {
        //    marginBottom: "0mm",
        //    marginTop: "0mm"
        //},
        /*display: "flex",
        flexDirection: "column",
        width: "1075px",
        margin: "auto",*/
        //height: "100vh",
        //overflow: "auto",
    }

    const tdcenter = {
        textAlign: 'center'
    }
    const tdleft = {
        textAlign: 'left'
    }
    const tdright = {
        textAlign: 'right'
    }
    const border = {
        border: '1px solid #000'
    }
    const borderBottom = {
        borderBottom: '1px solid #000'
    }

    //数量变更类型的表头
    const numTr = (
        <tr>
            <th style={{width: "10%", ...tdcenter, ...border}}>项号</th>
            <th style={{width: "24%", ...tdcenter, ...border}}>品名</th>
            <th style={{width: "8%", ...tdcenter, ...border}}>原数量</th>
            <th style={{width: "8%", ...tdcenter, ...border}}>增加数量</th>
            <th style={{width: "8%", ...tdcenter, ...border}}>现数量</th>
            <th style={{width: "6%", ...tdcenter, ...border}}>单位</th>
            <th style={{width: "12%", ...tdcenter, ...border}}>原金额</th>
            <th style={{width: "12%", ...tdcenter, ...border}}>增加金额</th>
            <th style={{width: "12%", ...tdcenter, ...border}}>现金额</th>
        </tr>
    )


    return (
        <div id={"printContent"} css={printCss} style={{height: '100%'}}>
            <div className={"print-content"}>
                <div className="order-edit-content" style={{width: "1075px"}}>
                    <table width="1075" className="print-table">
                        <thead>
                        <tr>
                            <td>
                                <div style={{paddingTop: "15px"}}>
                                    <div style={{
                                        textAlign: "center",
                                        fontSize: "22px",
                                        fontWeight: "bold"
                                    }}>申请变更
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>
                                <div style={{padding: "10px 0px", width: "1075px"}}>
                                    <div className="l"><b>{epim?.customName}：</b></div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div style={{padding: "10px 0px", width: "1075px", textIndent: '2em'}}>
                                    <div className="l">
                                        <b>我司手册 {epim?.epimRlsNo} 因 {epim?.altReason} 原因。故申请变更,具体如下:</b>
                                    </div>
                                    <div className="clear"></div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    {

                        pnumList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[0]}、出口变更</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                {numTr}
                                </thead>
                                <tbody>

                                {
                                    pnumList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.epimProwNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.goodsNameCn}</td>
                                                <td style={{...tdright, ...border}}>{i.originEpimPqty}</td>
                                                <td style={{...tdright, ...border}}>{i.addPqty}</td>
                                                <td style={{...tdright, ...border}}>{i.epimPqty}</td>
                                                <td style={{...tdcenter, ...border}}>{i.uomName}</td>
                                                <td style={{...tdright, ...border}}>{i.originEpimPamt}</td>
                                                <td style={{...tdright, ...border}}>{i.addPamt}</td>
                                                <td style={{...tdright, ...border}}>{i.epimPamt}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>

                                    <td style={{...tdright, ...border}}>{epimPamtTotal}</td>
                                    <td style={{...tdright, ...border}}>{addPamtTotal}</td>
                                    <td style={{...tdright, ...border}}>{originEpimPamtTotal}</td>
                                </tr>
                                <tr>
                                    <td style={{...borderBottom}}><b>出口总金额</b></td>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>

                                    <td style={{...tdright, ...border}}>{epim?.initpmt}</td>
                                    <td style={{...tdright, ...border}}>{epim?.addpmt}</td>
                                    <td style={{...tdright, ...border}}>{epim?.currpmt}</td>
                                </tr>
                                </tbody>
                            </table>
                        </>
                    }
                    {
                        mnumList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[1]}、进口变更</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                {numTr}
                                </thead>
                                <tbody>
                                {
                                    mnumList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.epimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.mmCdNameCn}</td>
                                                <td style={{...tdright, ...border}}>{i.originReqQty}</td>
                                                <td style={{...tdright, ...border}}>{i.addReqty}</td>
                                                <td style={{...tdright, ...border}}>{i.reqQty}</td>
                                                <td style={{...tdcenter, ...border}}>{i.uomName}</td>
                                                <td style={{...tdright, ...border}}>{fixNum(i.originEpimRowAmt, 2)}</td>
                                                <td style={{...tdright, ...border}}>{fixNum(i.addRowAmt, 2)}</td>
                                                <td style={{...tdright, ...border}}>{fixNum(i.epimRowAmt, 2)}</td>
                                            </tr>
                                        )
                                    })
                                }
                                <tr>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td/>
                                    <td style={{...tdright, ...border}}>{fixNum(epimRowAmtTotal, 2)}</td>
                                    <td style={{...tdright, ...border}}>{fixNum(addRowAmtTotal, 2)}</td>
                                    <td style={{...tdright, ...border}}>{fixNum(originEpimRowAmtTotal, 2)}</td>
                                </tr>
                                <tr>
                                    <td style={{...borderBottom}}><b>进口总金额</b></td>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...borderBottom}}/>
                                    <td style={{...tdright, ...border}}>{fixNum(epim?.initRowAmt, 2)}</td>
                                    <td style={{...tdright, ...border}}>{fixNum(epim?.addRowAmt, 2)}</td>
                                    <td style={{...tdright, ...border}}>{fixNum(epim?.currRowAmt, 2)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </>
                    }

                    {
                        consumptionList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[2]}、单耗变更</b></div>
                                <div className="clear"></div>
                            </div>

                            {
                                consumptionProwNoLists.map(prowNoList => {
                                    return (
                                        <>
                                            <table width="1075" className="print-table"
                                                   style={{margin: '0px 0px 30px 0px'}}>
                                                <thead>
                                                <tr>
                                                    <th rowSpan={2}
                                                        style={{width: "10%", ...tdcenter, ...border}}>项号
                                                    </th>
                                                    <th rowSpan={2}
                                                        style={{width: "24%", ...tdcenter, ...border}}>品名
                                                    </th>
                                                    {
                                                        prowNoList.map(prowNo => {
                                                            if (prowNo.epimProwNo) {
                                                                return (
                                                                    <th colSpan={2}
                                                                        style={{width: "22%", ...tdcenter, ...border}}>{prowNo.epimProwNo}</th>
                                                                );
                                                            } else {
                                                                return (
                                                                    <th colSpan={2}></th>
                                                                );
                                                            }
                                                        })
                                                    }

                                                </tr>
                                                <tr>
                                                    {
                                                        prowNoList.map(prowNo => {
                                                            if (prowNo.epimProwNo) {

                                                                return (
                                                                    <>
                                                                        <th style={{...tdcenter, ...border}}>原单耗</th>
                                                                        <th style={{...tdcenter, ...border}}>现单耗</th>
                                                                    </>
                                                                );
                                                            } else {

                                                                return (
                                                                    <>
                                                                        <th></th>
                                                                    </>
                                                                );
                                                            }
                                                        })
                                                    }
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    consumptionMrowNoList.map(mrowNo => {
                                                        let mrow = consumptionList.find(i => Number(i.epimMrowNo) === mrowNo)??[0];
                                                        return (
                                                            <tr>
                                                                <td style={{...tdcenter, ...border}}>{mrowNo}</td>
                                                                <td style={{...tdcenter, ...border}}>{mrow?.mmCdNameCn}</td>
                                                                {
                                                                    prowNoList.map(prowNo => {
                                                                        if (prowNo.epimProwNo) {
                                                                            let consumption = consumptionList.find(consumption => {
                                                                                return Number(consumption.epimProwNo) === prowNo.epimProwNo
                                                                            });
                                                                            return (
                                                                                <>
                                                                                    <td style={{...tdcenter, ...border}}>{consumption?.originEpimConsumeRate}</td>
                                                                                    <td style={{...tdcenter, ...border}}>{consumption?.epimConsumeRate}</td>
                                                                                </>
                                                                            );
                                                                        } else {
                                                                            return (
                                                                                <>
                                                                                    <td></td>
                                                                                </>
                                                                            );
                                                                        }

                                                                    })
                                                                }
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </>
                                    );
                                })
                            }
                        </>
                    }

                    {
                        specList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[3]}、品名、规格变更:</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                <tr>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>项号</th>
                                    <th style={{width: "24%", ...tdcenter, ...border}}>原品名</th>
                                    <th style={{width: "24%", ...tdcenter, ...border}}>现品名</th>
                                    <th style={{width: "18%", ...tdcenter, ...border}}>原规格</th>
                                    <th style={{width: "18%", ...tdcenter, ...border}}>现规格</th>
                                    <th style={{width: "8%", ...tdcenter, ...border}}>有否进/出过料</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    specList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PSPEC' ? i.epimProwNo : i.epimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PSPEC' ? i.originPbosCdNameCn : i.originMmCdNameCn}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PSPEC' ? i.pbosCdNameCn : i.mmCdNameCn}</td>
                                                <td style={{...tdleft, ...border}}>{i.originFabricComp}</td>
                                                <td style={{...tdleft, ...border}}>{i.fabricComp}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PSPEC' ? i.hasExportedFlag ? '已出口' : '未出口' : i.hasImportedFlag ? '已进口' : '未进口'}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </>
                    }

                    {
                        hsAlterList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[4]}、成品海关编码变更:</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                <tr>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>项号</th>
                                    <th style={{width: "24%", ...tdcenter, ...border}}>品名</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>原商品编码</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>现商品编码</th>
                                    <th style={{width: "15%", ...tdcenter, ...border}}>现规格</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    hsAlterList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PNO' ? i.epimProwNo : i.epimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PNO' ? i.originPbosCdNameCn : i.originMmCdNameCn}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PNO' ? i.originPHsCode : i.originMmHsCode}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PNO' ? i.pHsCode : i.hsCode}</td>
                                                <td style={{...tdleft, ...border}}>{i.alterRowType === 'PNO' ? i.fabricComp : i.goodsSpecDescCn}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </>
                    }

                    {
                        pHsDeclareAlterList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[5]}、成品申报要素变更:</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                <tr>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>项号</th>
                                    <th style={{width: "24%", ...tdcenter, ...border}}>品名</th>
                                    <th style={{width: "20%", ...tdcenter, ...border}}>原申报要素</th>
                                    <th style={{width: "20%", ...tdcenter, ...border}}>现申报要素</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    pHsDeclareAlterList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PDC' ? i.epimProwNo : i.epimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PDC' ? i.originPbosCdNameCn : i.originMmCdNameCn}</td>
                                                <td style={{...tdleft, ...border}}>{i.originPHsDeclareCd}</td>
                                                <td style={{...tdleft, ...border}}>{i.pHsDeclareCd}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </>
                    }
                    {
                        mHsDeclareAlterList.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                <div className="l"><b>{tableCount[6]}、料件申报要素变更:</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                <tr>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>项号</th>
                                    <th style={{width: "24%", ...tdcenter, ...border}}>品名</th>
                                    <th style={{width: "20%", ...tdcenter, ...border}}>原申报要素</th>
                                    <th style={{width: "20%", ...tdcenter, ...border}}>现申报要素</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    mHsDeclareAlterList.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PDC' ? i.epimProwNo : i.epimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.alterRowType === 'PDC' ? i.originPbosCdNameCn : i.originMmCdNameCn}</td>
                                                <td style={{...tdleft, ...border}}>{i.originPHsDeclareCd}</td>
                                                <td style={{...tdleft, ...border}}>{i.pHsDeclareCd}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </>
                    }

                    {
                        epimMtrfRows.length > 0 &&
                        <>
                            <div style={{padding: "30px 0px", width: "1075px"}}>
                                {/*<div className="l"><b>{tableCount[5]}、结转变更:</b></div>*/}
                                <div className="l"><b>1、结转变更:</b></div>
                                <div className="clear"></div>
                            </div>
                            <table width="1075" className="print-table">
                                <thead>
                                <tr>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>转出手册号</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>转出料件项号</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>料件名称</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>海关编码</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>规格型号</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>转入项号</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>转入料件数</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>余料净重(KGS)</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>余料毛重(KGS)</th>
                                    <th style={{width: "10%", ...tdcenter, ...border}}>余料体积(CBM)</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    epimMtrfRows.map(i => {
                                        return (
                                            <tr>
                                                <td style={{...tdcenter, ...border}}>{epimMtrf?.outEpimRlsNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.outEpimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.outCdNameCn}</td>
                                                <td style={{...tdcenter, ...border}}>{i.outHsCode}</td>
                                                <td style={{...tdcenter, ...border}}>{i.goodsSpecDescCn}</td>
                                                <td style={{...tdcenter, ...border}}>{i.inEpimMrowNo}</td>
                                                <td style={{...tdcenter, ...border}}>{i.mtrfOddsQty}</td>
                                                <td style={{...tdcenter, ...border}}>{i.mtrfOddsNw}</td>
                                                <td style={{...tdcenter, ...border}}>{i.mtrfOddsGw}</td>
                                                <td style={{...tdcenter, ...border}}>{i.mtrfOddsVol}</td>
                                            </tr>
                                        )
                                    })
                                }
                                </tbody>
                            </table>
                        </>
                    }
                    <div style={{padding: "50px 0px", width: "1075px"}}>
                    </div>
                    <table width="1075" className="print-table">
                        <thead>
                        <tr>
                            <th style={{width: "20%", ...tdcenter}}>
                                希批准为盼！
                            </th>
                            <th style={{width: "20%", ...tdcenter}}></th>
                            <th style={{width: "20%", ...tdcenter}}></th>
                            <th style={{width: "30%", ...tdcenter}}></th>
                            <th style={{width: "10%", ...tdcenter}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{...tdcenter}}>{epim?.coNameCn}</td>
                            <td></td>
                        </tr>
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td style={{...tdcenter}}>{moment(new Date()).format(dateFormat)}</td>
                            <td></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default EPIMALTER;
